import React from 'react';
import styled from 'styled-components';
import { useParams } from 'react-router-dom';
import { ApplicantParticularsBox } from './ApplicantParticularsBox';
import { PAGE_TEXT } from '../../../../lang';
import { useGetApplicantParticulars } from '../../../../graphql/DRCAssessment';
import { Accordion, Loading, Alert } from '../../../../../../components';

type ApplicantParticularsProps = {
  showGoDetail?: boolean;
};

export const ApplicantParticulars: React.FunctionComponent<
  ApplicantParticularsProps
> = (props: ApplicantParticularsProps) => {
  const { applicationId } = useParams();
  const { showGoDetail = false } = props;

  const { applicantParticulars, loading, error } = useGetApplicantParticulars(
    applicationId ?? '',
  );

  if (error)
    return (
      <Alert
        openAlert={true}
        setOpenAlert={() => {}}
        alertDetails={{
          alertContent: 'Error Occurs.' + (error as Error)?.message,
          alertType: 'error',
        }}
      />
    );

  const { DRC_ASSESSMENT_DETAILS } = PAGE_TEXT;
  const PARTICULARS_TEXT = DRC_ASSESSMENT_DETAILS.PARTICULARS;

  return (
    <div>
      {loading ? (
        <Loading />
      ) : (
        <ContentBox>
          <Accordion
            className="w-full"
            defaultExpanded
            title={PARTICULARS_TEXT.TITLE}
            details={
              <ApplicantParticularsBox
                applicantParticulars={applicantParticulars}
                showGoDetail={showGoDetail}
              />
            }
          />
        </ContentBox>
      )}
    </div>
  );
};

const ContentBox = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  flex: 1;

  Accordion {
    margin-bottom: 1rem;
  }
`;
